import { render } from "datocms-structured-text-to-plain-text"
import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import { StructuredText } from "react-datocms"
import SwiperCore, { Navigation } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper-bundle.css"

import { TestimonialSliderStyles } from "../../styles/Components/TestimonialSlider"
import Heading from "../../utils/OptimizedHeading"
import Img from "../../utils/OptimizedImage"
SwiperCore.use([Navigation])

const TestimonialSlider = ({ component, grid }) => {
  const bgClass = component?.background?.replace(/ /g, "").toLowerCase()
  const type = !!(
    component?.testimonial &&
    component?.testimonial.length > 0 &&
    component?.testimonial[0]?.thumbnail
  )

  return (
    <TestimonialSliderStyles
      className={`bg-${bgClass} container-${
        grid !== "" ? grid?.toLowerCase() : "normal"
      }`}
    >
      <Container>
        <Row>
          <Col>
            <div className="heading-container">
              {component?.eyebrow && (
                <p className="heading-kicker eyebrow">{component?.eyebrow}</p>
              )}
              {component?.heading && (
                <Heading
                  type={component?.headingSize}
                  string={component?.heading}
                  className="heading"
                />
              )}
              {render(component?.testiBody)?.length > 0 && (
                <div className="description mb-5">
                  <StructuredText
                    data={component?.testiBody}
                    renderInlineRecord={() => {}}
                  />
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col>
            {type ? (
              <div className="swiperImg">
                <Swiper navigation={true} slidesPerView={1} spaceBetween={80}>
                  {component?.testimonial &&
                    component?.testimonial.length > 0 &&
                    component?.testimonial.map((item, index) => (
                      <SwiperSlide key={index}>
                        <Row className="mx-0 align-items-center">
                          <Col lg={5} xl={4} className="px-0">
                            <div className="media">
                              <Img src={item?.thumbnail?.url} />
                            </div>
                          </Col>
                          <Col lg={7} xl={8}>
                            <div className="item-desc">
                              <p>{item?.testimonial}</p>
                              <p>
                                <strong>{item?.person?.fullName}</strong> -{" "}
                                {item?.person?.role}
                              </p>
                            </div>
                          </Col>
                        </Row>
                      </SwiperSlide>
                    ))}
                </Swiper>
              </div>
            ) : (
              <div className="swipernoImg">
                <Swiper navigation={true} slidesPerView={1} spaceBetween={80}>
                  {component?.testimonial &&
                    component?.testimonial.length > 0 &&
                    component?.testimonial.map((item, index) => (
                      <SwiperSlide key={index}>
                        <Row className="mx-0 align-items-center justify-content-center text-center">
                          <Col lg={10} xl={10}>
                            <div className="item-desc">
                              <p className="description">{item?.testimonial}</p>
                              <p className="author">
                                <strong>{item?.person?.fullName}</strong> -{" "}
                                {item?.person?.role}
                              </p>
                            </div>
                          </Col>
                        </Row>
                      </SwiperSlide>
                    ))}
                </Swiper>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </TestimonialSliderStyles>
  )
}

export default TestimonialSlider
